export type UrgencyLevel = 'red' | 'yellow' | 'gray';

/**
 * Devuelve el nivel de urgencia del cupon segun cuantos dias faltan
 * para su vencimiento. red <=7, yellow 8-30, gray 31+.
 */
export function getUrgencyLevel(dueDate: string, today: string): UrgencyLevel {
    const days = getDaysUntilDue(dueDate, today);
    if (days <= 7) return 'red';
    if (days <= 30) return 'yellow';
    return 'gray';
}

export function getDaysUntilDue(dueDate: string, today: string): number {
    const due = new Date(dueDate + 'T00:00:00Z').getTime();
    const now = new Date(today + 'T00:00:00Z').getTime();
    const msPerDay = 24 * 60 * 60 * 1000;
    return Math.round((due - now) / msPerDay);
}
